import React from 'react';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import './index.css'; // Import the new CSS file

const ModalComponent = props => (
  <Modal show={props.show} size={props.size} onHide={props.onHide} {...props}>
    <Modal.Header closeButton className="custom-modal-header">
      {props.title ? (
        <Modal.Title style={{ textAlign: 'center', width: '100%' }}>
          {props.title}
        </Modal.Title>
      ) : null}
      {props.headerContent ? props.headerContent : null}
    </Modal.Header>
    {props.children}

    {props.footer ? <Modal.Footer>
      {props.footer ? props.footer : null}
      <Button
        variant="primary"
        onClick={props.onHide}
        style={{ display: 'none' }}
      >
        Close
      </Button>
    </Modal.Footer>
    :null }
  </Modal>
);

export default ModalComponent;
